import { Link } from "react-router";
import { Shield } from "lucide-react";
import {
  CompliancePageHeader,
  ComplianceUnavailableState,
} from "./shared";

export default function ComplianceDashboardPage() {
  return (
    <div className="space-y-6">
      <CompliancePageHeader
        icon={<Shield className="h-6 w-6 text-[var(--color-primary)]" />}
        title="Compliance Health"
        description="This page no longer guesses a score from dead placeholders."
      />

      <ComplianceUnavailableState
        title="Compliance scoring is not implemented yet"
        description="`api-platform` has no authoritative health-score contract for these settings surfaces. This page stays explicit until a real backend score model is wired."
      >
        <div className="flex justify-center gap-3">
          <Link to="/settings/compliance/consent" className="rounded-lg bg-[var(--color-primary)] px-4 py-2 text-sm font-medium text-white hover:opacity-90">
            Review consent records
          </Link>
          <Link to="/settings/compliance/delete-request" className="rounded-lg border border-[var(--color-border)] px-4 py-2 text-sm text-[var(--color-foreground)] hover:bg-[var(--color-surface)]">
            Manage erasure requests
          </Link>
        </div>
      </ComplianceUnavailableState>
    </div>
  );
}
